import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { URLS } from "../Services/Constant";
import { post } from "../Services/ApiHandler";

import {
  act_flag,
  admin_act_icon,
  admin_icon,
  bell_gray,
  bell_purple,
  Block_active,
  Block_Deactive,
  booking,
  booking_act,
  Cardholder,
  CardholderActive,
  coupon_active,
  coupon_deactive,
  dec_flag,
  guidelines,
  guidelines_act,
  invoice_gray_Icon,
  invoice_purpple_Icon,
  logo,
  master_act_icon,
  master_icon,
  mmc_act,
  mmc_icon,
  property,
  property_act,
  Receptionist,
  ReceptionistWhite,
  refer_icon,
  review_active,
  review_deactive,
  sos,
  sosactive,
  SubtitlesSlash,
  SubtitlesSlashActive,
  transaction,
  transaction_act,
  user_act_icon,
  user_icon,
  vow_settings,
  Wallet,
  Wallet_act,
  wishlist,
} from "../assets/img";
import { toast } from "react-toastify";
import { checkPermission } from "../screen/redux/api/PermissionManager";
import { ref, onValue } from "firebase/database";
import { database } from "../firebase/firebase";
const getIPAddress = async () => {
  try {
    const localIP = await new Promise((resolve, reject) => {
      const pc = new RTCPeerConnection({ iceServers: [] });
      pc.createDataChannel("");
      pc.createOffer().then((offer) => pc.setLocalDescription(offer));

      pc.onicecandidate = (event) => {
        if (!event.candidate) return;
        const ipMatch = event.candidate.candidate.match(
          /(\d{1,3}\.){3}\d{1,3}/,
        );
        if (ipMatch && !ipMatch[0].startsWith("0.")) {
          resolve(ipMatch[0]);
          pc.close();
        }
      };

      setTimeout(() => reject(new Error("WebRTC timeout")), 1000);
    });

    if (localIP) return localIP;
  } catch {
    console.warn("WebRTC blocked (likely Brave), trying public API...");
  }

  try {
    const res = await fetch("https://api4.ipify.org?format=json");
    const data = await res.json();
    return data.ip;
  } catch {
    console.error("Public API also failed");
    return "Unknown IP";
  }
};
const ProfileNavBar = ({ setSaidList }) => {
  const [saideBarShow, setSaidBarShow] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [popup, setPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState();

  const [isActiveViewNotification, setIsActiveViewNotification] =
    useState("user_list/customer");
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const [isCount, setIsCount] = useState();
  const toggleSidebar = () => {
    setSaidBarShow(!saideBarShow);
    setActiveMenu(null);
  };
  const getDeviceInfo = async () => {
    const userAgent = navigator.userAgent;
    let os = "Unknown OS";
    if (/windows/i.test(userAgent)) os = "Windows";
    else if (/android/i.test(userAgent)) os = "Android";
    else if (/iphone|ipad|ipod/i.test(userAgent)) os = "iOS";
    else if (/mac/i.test(userAgent)) os = "MacOS";
    else if (/linux/i.test(userAgent)) os = "Android";

    let browser = "Unknown Browser";
    const isBrave =
      navigator.brave && (await navigator.brave.isBrave()) === true;

    if (isBrave) browser = "Brave";
    else if (/firefox/i.test(userAgent)) browser = "Firefox";
    else if (/edg/i.test(userAgent)) browser = "Edge";
    else if (/opr|opera/i.test(userAgent)) browser = "Opera";
    else if (/chrome/i.test(userAgent)) browser = "Chrome";
    else if (/safari/i.test(userAgent)) browser = "Safari";
    let deviceType = "Desktop";
    if (/mobile/i.test(userAgent)) deviceType = "Mobile";
    else if (/tablet|ipad/i.test(userAgent)) deviceType = "Tablet";
    const ip_address = await getIPAddress();

    const deviceInfo = {
      os,
      browser,
      deviceType,
      ip_address,
      userAgent,
      language: navigator.language,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      online: navigator.onLine,
      platform: navigator.platform,
    };
    setDeviceInfo(deviceInfo);
  };
  useEffect(() => {
    getDeviceInfo();
  }, []);
  //firebase listerning
  useEffect(() => {
    // const dbRef = ref(database, `notifications_count/${isActiveViewNotification}`);
    const dbRef = ref(database, `notifications_count/`);
    const unsubscribe = onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      console.log("Realtime Data:", data);
      setIsCount(data);
      // sessionStorage.setItem("notification", JSON.stringify(data));
    });

    return () => unsubscribe();
  }, [isActiveViewNotification]);

  const handleMenuClick = (menuKey, defaultRoute) => {
    setSaidBarShow(true);
    setActiveMenu((prev) => (prev === menuKey ? null : menuKey));
    if (activeMenu !== menuKey && defaultRoute) {
      navigate(defaultRoute);
    }
  };

  const handleLogout = () => {
    setLoading(true);
    // Simulated logout logic; replace with API call as needed'
    let formdata = new FormData();
    formdata.append("ip_address", deviceInfo?.ip_address);
    formdata.append(
      "device_info",
      `${deviceInfo?.os} - ${deviceInfo?.browser}`,
    );
    post(URLS.LOGOUT, formdata)
      .then((res) => {
        // setBtn(false);
        if (res?.status == "success") {
          toast.success(res?.message);
          setTimeout(() => {
            localStorage.clear();
            setLoading(false);
            setPopup(false);
            navigate("/");
          }, 1000);
        }
      })
      .catch((err) => {
        // setBtn(false);
        console.log("err", err);
      });
  };

  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const checkMultiplePermission = (array = []) => {
    let show = false;
    array?.map((item) => {
      if (checkPermission(item)) show = true;
    });
    return show;
  };

  // Scroll to bottom when menu opens
  useEffect(() => {
    if (menuOpen && menuRef.current) {
      const el = menuRef.current;
      el.scrollTo({
        top: el.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [menuOpen]);

  const handleCloseMenu = () => {
    if (menuRef.current) {
      menuRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    setTimeout(() => setMenuOpen(false), 300); // wait for scroll then close
  };
  console.log("isCountisCount", isCount, isCount?.user_list?.owner == 0);

  return (
    <div className={`${saideBarShow ? "sidebar" : "close_sidebar"}`}>
      <header>
        <div className="image_text pointer d-flex ac-jc">
          <div className="d-flex ac-js p-2 mt-2">
            <img src={logo} className="logo" alt="logo" />
            {saideBarShow && (
              <p className="f3 ms-2 fs-md-14 fs-xl-17 fs-xxl-20 mb-1 sec">
                Admin Panel
              </p>
            )}
          </div>
        </div>
      </header>

      <div onClick={toggleSidebar}>
        {saideBarShow ? (
          <KeyboardDoubleArrowLeftIcon className="arrow-right" />
        ) : (
          <KeyboardDoubleArrowRightIcon className="arrow-left" />
        )}
      </div>

      <div ref={menuRef} className="menu_bar overflow-x-hidden overflow-scroll">
        <div className="menu">
          <ul className="menu_links ps-0">
            {/* Super Admin Menu */}
            {checkMultiplePermission([
              "CAN-LIST-ADMIN_LIST",
              "CAN-LIST-DASHBOARD",
              "CAN-LIST-ADMIN_ROLES",
            ]) && (
              <li
                className="nav_link trans"
                onClick={() =>
                  handleMenuClick(
                    "dashboard",
                    checkPermission("CAN-LIST-DASHBOARD")
                      ? "/dashboard"
                      : checkPermission("CAN-LIST-ADMIN_LIST")
                        ? "/admin"
                        : checkPermission("CAN-LIST-ADMIN_ROLES")
                          ? "/roles"
                          : "",
                  )
                }
              >
                <h4
                  className={`ps-3 ${
                    [
                      "dashboard",
                      "admin",
                      "add-admin",
                      "roles",
                      "add-roles",
                    ].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <img
                    src={
                      [
                        "dashboard",
                        "admin",
                        "add-admin",
                        "roles",
                        "add-roles",
                      ].includes(splitLocation[1])
                        ? admin_act_icon
                        : admin_icon
                    }
                    className="icon"
                    alt=""
                  />
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                    Super Admin <KeyboardArrowDownOutlinedIcon />
                  </span>
                </h4>
              </li>
            )}
            {activeMenu === "dashboard" && (
              <ul className="sub-menu show">
                {checkPermission("CAN-LIST-DASHBOARD") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/dashboard");
                      // setIsActiveViewNotification("settings/daily_log");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "dashboard" ? "f3 sub_active" : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      Dashboard
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-ADMIN_LIST") && (
                  <li
                    className="nav_link trans my-1"
                    onClick={() => navigate("/admin")}
                  >
                    <h4
                      className={`${
                        ["admin", "add-admin"].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      Admin List
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-ADMIN_ROLES") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/roles");
                      setIsActiveViewNotification("notification/user_list");
                    }}
                  >
                    <h4
                      className={`${
                        ["roles", "add-roles"].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      Admin Roles
                    </h4>
                  </li>
                )}
              </ul>
            )}
            {/* User List */}
            {checkMultiplePermission([
              "CAN-LIST-CUSTOMER",
              "CAN-LIST-OWNER",
              "CAN-LIST-RECEPTIONIST",
              "CAN-LIST-DEACTIVATE",
            ]) && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick(
                    "users",
                    checkPermission("CAN-LIST-OWNER")
                      ? "/user-owner"
                      : checkPermission("CAN-LIST-CUSTOMER")
                        ? "/customer-list"
                        : checkPermission("CAN-LIST-RECEPTIONIST")
                          ? "/receptionist"
                          : checkPermission("CAN-LIST-DEACTIVATE")
                            ? "/deactivate"
                            : "",
                  );
                  setIsActiveViewNotification("user/user_owner");
                }}
              >
                <div
                  className={`ps-3 ${
                    [
                      "user-owner",
                      "add-owner",
                      "customer-list",
                      "customer-view",
                      "deactivate",
                      "receptionist",
                    ].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                  style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                >
                  <h4
                    style={{ margin: 0 }}
                    // className={`ps-3 ${
                    //   [
                    //     "mmc-transaction-list",
                    //     "mmc-suspended-list",
                    //     "mmc-suspend-view",
                    //     "mmc-cancel-appr-view",
                    //     "mmc-cancel-req-view",
                    //   ].includes(splitLocation[1])
                    //     ? "f3 active_bar"
                    //     : ""
                    // }`}
                  >
                    <img
                      src={
                        [
                          "user-owner",
                          "add-owner",
                          "customer-list",
                          "customer-view",
                          "deactivate",
                          "receptionist",
                        ].includes(splitLocation[1])
                          ? user_act_icon
                          : user_icon
                      }
                      className="icon"
                      alt=""
                    />
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                      User List{" "}
                      {(isCount?.user_list?.customer || 0) +
                        (isCount?.user_list?.owner || 0) >
                        0 && (
                        <span className="isCountvalueds">
                          {isCount?.user_list?.owner || 0}
                          <KeyboardArrowDownOutlinedIcon />
                        </span>
                      )}
                      {(isCount?.user_list?.owner || 0) === 0 && (
                        <KeyboardArrowDownOutlinedIcon />
                      )}
                    </span>
                  </h4>
                </div>
              </li>
            )}
            {activeMenu === "users" && (
              <ul className="sub-menu show">
                {checkPermission("CAN-LIST-OWNER") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/user-owner");
                      setIsActiveViewNotification("user/user_owner");
                    }}
                  >
                    <h4
                      className={`${
                        ["user-owner", "add-owner"].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      Owner
                    </h4>
                    {isCount?.user_list?.owner > 0 && (
                      <span className="isCountvalued">
                        {isCount?.user_list?.owner}
                      </span>
                    )}
                  </li>
                )}
                {checkPermission("CAN-LIST-CUSTOMER") && (
                  <li
                    className="nav_link trans my-1"
                    onClick={() => {
                      navigate("/customer-list");
                      setIsActiveViewNotification("user/customer_list");
                    }}
                  >
                    <h4
                      className={`${
                        ["customer-list", "customer-view"].includes(
                          splitLocation[1],
                        )
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      Customer
                    </h4>
                    {/* {isCount?.user_list?.customer > 0 && (
                      <span className="isCountvalued">
                        {isCount?.user_list?.customer}
                      </span>
                    )} */}
                  </li>
                )}

                {checkPermission("CAN-LIST-RECEPTIONIST") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/receptionist");
                      setIsActiveViewNotification("notification/absent_list");
                    }}
                  >
                    <h4
                      className={`${
                        ["receptionist", "receptionist-action"].includes(
                          splitLocation[1],
                        )
                          ? "f3 sub_active"
                          : ""
                      } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      Receptionist
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-DEACTIVATE") && (
                  <li
                    className="nav_link trans my-1"
                    onClick={() => {
                      navigate("/deactivate");
                      setIsActiveViewNotification("user/deactivate");
                    }}
                  >
                    <h4
                      className={`${
                        ["deactivate"].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      Deactivate
                    </h4>
                  </li>
                )}
              </ul>
            )}
            {/* Blocks */}
            {checkMultiplePermission([
              "CAN-LIST-ROOMS",
              "CAN-LIST-PROPERTIES",
            ]) && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick(
                    "rooms-block",
                    checkPermission("CAN-LIST-ROOMS")
                      ? "/rooms-block"
                      : checkPermission("CAN-LIST-PROPERTIES")
                        ? "/properties-block"
                        : "",
                  );
                  setIsActiveViewNotification("blocks/rooms_block");
                }}
              >
                <h4
                  className={`ps-3 ${
                    [
                      "rooms-block",
                      "rooms-block",
                      "",
                      "properties-block",
                      "rooms-block-view",
                    ].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <img
                    src={
                      [
                        "rooms-block",
                        "rooms-block",
                        "",
                        "properties-block",
                        "rooms-block-view",
                      ].includes(splitLocation[1])
                        ? Block_active
                        : Block_Deactive
                    }
                    className="icon"
                    alt=""
                  />
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                    Blocks <KeyboardArrowDownOutlinedIcon />
                  </span>
                </h4>
              </li>
            )}
            {activeMenu === "rooms-block" && (
              <ul className="sub-menu show">
                {checkPermission("CAN-LIST-ROOMS") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/rooms-block");
                      setIsActiveViewNotification("blocks/rooms_block");
                    }}
                  >
                    <h4
                      className={`${
                        ["rooms-block", "rooms-block-view"].includes(
                          splitLocation[1],
                        )
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Rooms
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-PROPERTIES") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/properties-block");
                      setIsActiveViewNotification("blocks/properties_block");
                    }}
                  >
                    <h4
                      className={`${
                        ["properties-block"].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Properties
                    </h4>
                  </li>
                )}
              </ul>
            )}
            {/* MMC */}
            {checkMultiplePermission([
              "CAN-LIST-MMC_TRANSACTION",
              "CAN-LIST-MMC_SUSPENDED",
              // "CAN-LIST-MMC_SUSPENDED",
              "CAN-LIST-MMC_CANCELLATION",
              "CAN-LIST-MMC_DEACTIVE",
            ]) && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick(
                    "mmc",
                    checkPermission("CAN-LIST-MMC_TRANSACTION")
                      ? "/mmc-transaction-list"
                      : checkPermission("CAN-LIST-MMC_SUSPENDED")
                        ? "/mmc-suspended-list"
                        : checkPermission("CAN-LIST-MMC_CANCELLATION")
                          ? "/mmc-cancellation-list"
                          : checkPermission("CAN-LIST-MMC_DEACTIVE")
                            ? "/mmc-deactive-list"
                            : "",
                  );
                  setIsActiveViewNotification("mmc/transaction_list");
                }}
              >
                <div
                  className={`ps-3 ${
                    [
                      "mmc-transaction-list",
                      "mmc-suspended-list",
                      "mmc-suspend-view",
                      "mmc-cancel-appr-view",
                      "mmc-cancel-req-view",
                      "mmc-deactive-list",
                    ].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                  style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                >
                  <h4
                    style={{ margin: 0 }}
                    // className={`ps-3 ${
                    //   [
                    //     "mmc-transaction-list",
                    //     "mmc-suspended-list",
                    //     "mmc-suspend-view",
                    //     "mmc-cancel-appr-view",
                    //     "mmc-cancel-req-view",
                    //   ].includes(splitLocation[1])
                    //     ? "f3 active_bar"
                    //     : ""
                    // }`}
                  >
                    <img
                      src={
                        [
                          "mmc-transaction-list",
                          "mmc-suspended-list",
                          "mmc-suspend-view",
                          "mmc-cancel-appr-view",
                          "mmc-cancel-req-view",
                          "mmc-deactive-list",
                        ].includes(splitLocation[1])
                          ? mmc_act
                          : mmc_icon
                      }
                      className="icon"
                      alt=""
                    />
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                      MMC{" "}
                      {(isCount?.mmc?.mmc_cancellation || 0) +
                        (isCount?.mmc?.mmc_transaction || 0) +
                        (isCount?.mmc?.mmc_suspended || 0) >
                        0 && (
                        <span className="isCountvalueds">
                          {(isCount?.mmc?.mmc_cancellation || 0) +
                            (isCount?.mmc?.mmc_transaction || 0) +
                            (isCount?.mmc?.mmc_suspended || 0)}
                          <KeyboardArrowDownOutlinedIcon />
                        </span>
                      )}
                      {(isCount?.mmc?.mmc_cancellation || 0) +
                        (isCount?.mmc?.mmc_transaction || 0) +
                        (isCount?.mmc?.mmc_suspended || 0) ===
                        0 && <KeyboardArrowDownOutlinedIcon />}
                    </span>
                  </h4>
                </div>
              </li>
            )}
            {activeMenu === "mmc" && (
              <ul className="sub-menu show">
                {checkPermission("CAN-LIST-MMC_TRANSACTION") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/mmc-transaction-list");
                      setIsActiveViewNotification("mmc/transaction_list");
                    }}
                  >
                    <h4
                      className={`${
                        ["mmc-transaction-list", "add-owner"].includes(
                          splitLocation[1],
                        )
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      MMC Transaction
                    </h4>
                    {isCount?.mmc?.mmc_transaction > 0 && (
                      <span className="isCountvalued">
                        {isCount?.mmc?.mmc_transaction}
                      </span>
                    )}
                  </li>
                )}
                {checkPermission("CAN-LIST-MMC_SUSPENDED") && (
                  <li
                    className="nav_link trans my-1"
                    onClick={() => {
                      navigate("/mmc-suspended-list");
                      setIsActiveViewNotification("mmc/suspended_list");
                    }}
                  >
                    <h4
                      className={`${
                        ["mmc-suspended-list", "mmc-suspend-view"].includes(
                          splitLocation[1],
                        )
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      MMC Suspended
                    </h4>
                    {isCount?.mmc?.mmc_suspended > 0 && (
                      <span className="isCountvalued">
                        {isCount?.mmc?.mmc_suspended}
                      </span>
                    )}
                  </li>
                )}
                {checkPermission("CAN-LIST-MMC_CANCELLATION") && (
                  <li
                    className="nav_link trans my-1"
                    onClick={() => navigate("/mmc-cancellation-list")}
                  >
                    <h4
                      className={`${
                        [
                          "mmc-cancellation-list",
                          "mmc-cancel-req-view",
                          "mmc-cancel-appr-view",
                        ].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      MMC Cancellation
                    </h4>
                    {isCount?.mmc?.mmc_cancellation > 0 && (
                      <span className="isCountvalued">
                        {isCount?.mmc?.mmc_cancellation}
                      </span>
                    )}
                  </li>
                )}
                {checkPermission("CAN-LIST-MMC_DEACTIVE") && (
                  <li
                    className="nav_link trans my-1"
                    onClick={() => navigate("/mmc-deactive-list")}
                  >
                    <h4
                      className={`${
                        [
                          // "mmc-cancellation-list",
                          // "mmc-cancel-req-view",
                          // "mmc-cancel-appr-view",
                          "mmc-deactive-list",
                        ].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0`}
                    >
                      AutoPay Canceled
                    </h4>
                    {/* {isCount?.mmc?.mmc_cancellation > 0 && (
                      <span className="isCountvalued">
                        {isCount?.mmc?.mmc_cancellation}
                      </span>
                    )} */}
                  </li>
                )}
              </ul>
            )}
            {/* Properties */}
            {checkMultiplePermission([
              "CAN-LIST-OVERALL_PROPERTIES",
              "CAN-LIST-REQUESTED",
              "CAN-LIST-DOCUMENT_VERIFICATION",
              "CAN-LIST-MMC",
              "CAN-LIST-REJECTED",
            ]) && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick(
                    "Properties",
                    checkPermission("CAN-LIST-OVERALL_PROPERTIES")
                      ? "/overall-properties"
                      : checkPermission("CAN-LIST-REQUESTED")
                        ? "/properties"
                        : checkPermission("CAN-LIST-DOCUMENT_VERIFICATION")
                          ? "/properties-doc-verfication"
                          : checkPermission("CAN-LIST-MMC")
                            ? "/properties-mmc"
                            : checkPermission("CAN-LIST-REJECTED")
                              ? "/properties-rejected"
                              : "",
                  );
                  setIsActiveViewNotification("properties/overall_properties");
                }}
              >
                <div
                  className={`ps-3 ${
                    [
                      "room-list-view",
                      "room-transaction-view",
                      "mmc-transaction-view",
                      "mmc-suspended-view",
                      "cancel-req-view",
                      "cancel-appr-view",
                      "room-booking-block",
                      "room-booking-view",
                      "properties",
                      "property-details",
                      "overall-properties",
                      "propertie-req-edit",
                      "propertie-doc-edit",
                      "propertie-mmc-edit",
                      "properties-doc-verfication",
                      "properties-mmc",
                      "properties-rejected",
                      "doc-verfication-edit",
                      "doc-verfication-mmc",
                    ].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                  style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                >
                  <h4
                    style={{ margin: 0 }}
                    // className={`ps-3 ${
                    //   [
                    //     "mmc-transaction-list",
                    //     "mmc-suspended-list",
                    //     "mmc-suspend-view",
                    //     "mmc-cancel-appr-view",
                    //     "mmc-cancel-req-view",
                    //   ].includes(splitLocation[1])
                    //     ? "f3 active_bar"
                    //     : ""
                    // }`}
                  >
                    <img
                      src={
                        [
                          "room-list-view",
                          "room-transaction-view",
                          "mmc-transaction-view",
                          "mmc-suspended-view",
                          "cancel-req-view",
                          "cancel-appr-view",
                          "room-booking-block",
                          "room-booking-view",
                          "properties",
                          "property-details",
                          "overall-properties",
                          "propertie-req-edit",
                          "propertie-doc-edit",
                          "propertie-mmc-edit",
                          "properties-doc-verfication",
                          "properties-mmc",
                          "properties-rejected",
                          "doc-verfication-edit",
                          "doc-verfication-mmc",
                        ].includes(splitLocation[1])
                          ? property_act
                          : property
                      }
                      className="icon"
                      alt=""
                    />
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                      Properties
                      {/* <KeyboardArrowDownOutlinedIcon /> */}
                      {/* </span> */}
                      {isCount?.properties?.requested > 0 && (
                        <span className="isCountvalueds">
                          {isCount?.properties?.requested}
                          <KeyboardArrowDownOutlinedIcon />
                        </span>
                      )}
                      {(isCount?.properties?.requested || 0) === 0 && (
                        <span className="isCountvalueds">
                          <KeyboardArrowDownOutlinedIcon />
                        </span>
                      )}
                    </span>
                  </h4>
                </div>
              </li>
            )}
            {activeMenu === "Properties" && (
              <ul className="sub-menu show">
                {checkPermission("CAN-LIST-OVERALL_PROPERTIES") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/overall-properties");
                      setIsActiveViewNotification(
                        "properties/overall_properties",
                      );
                    }}
                  >
                    <h4
                      className={`${
                        [
                          "room-list-view",
                          "room-transaction-view",
                          "mmc-transaction-view",
                          "mmc-suspended-view",
                          "cancel-req-view",
                          "cancel-appr-view",
                          "overall-properties",
                          "property-details",
                          "room-booking-view",
                          "room-booking-block",
                        ].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Overall Properties
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-REQUESTED") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/properties");
                      setIsActiveViewNotification("properties/properties");
                    }}
                  >
                    <h4
                      className={`${
                        ["properties", "propertie-req-edit"].includes(
                          splitLocation[1],
                        )
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Requested
                    </h4>
                    {isCount?.properties?.requested > 0 && (
                      <span className="isCountvalued">
                        {isCount?.properties?.requested}
                      </span>
                    )}
                  </li>
                )}
                {checkPermission("CAN-LIST-DOCUMENT_VERIFICATION") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/properties-doc-verfication");
                      setIsActiveViewNotification(
                        "properties/property_doc_verification",
                      );
                    }}
                  >
                    <h4
                      className={`${
                        [
                          "properties-doc-verfication",
                          "propertie-doc-edit",
                        ].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Document Verification
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-MMC") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/properties-mmc");
                      setIsActiveViewNotification("properties/property_mmc");
                    }}
                  >
                    <h4
                      className={`${
                        ["properties-mmc", "propertie-mmc-edit"].includes(
                          splitLocation[1],
                        )
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      MMC
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-REJECTED") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/properties-rejected");
                      setIsActiveViewNotification(
                        "properties/property_rejected",
                      );
                    }}
                  >
                    <h4
                      className={`${
                        ["properties-rejected", "properties-rejected"].includes(
                          splitLocation[1],
                        )
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Rejected
                    </h4>
                  </li>
                )}
              </ul>
            )}
            {checkMultiplePermission([
              "CAN-LIST-PROPERTY__RED_FLAG",
              "CAN-LIST-PROPERTY__BLUE_FLAG",
            ]) && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick(
                    "PropertyFlag",
                    checkPermission("CAN-LIST-PROPERTY__BLUE_FLAG")
                      ? "/property-flag-blue"
                      : checkPermission("CAN-LIST-PROPERTY__RED_FLAG")
                        ? "/property-flag-red"
                        : "",
                  );
                  setIsActiveViewNotification("property_flag/blue");
                }}
              >
                <div
                  className={`ps-3 ${
                    ["property-flag-blue", "property-flag-red"].includes(
                      splitLocation[1],
                    )
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <h4 style={{ margin: 0 }}>
                    <img
                      src={
                        ["property-flag-blue", "property-flag-red"].includes(
                          splitLocation[1],
                        )
                          ? act_flag
                          : dec_flag
                      }
                      className="icon"
                      alt=""
                    />
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                      Property Flag
                      {(isCount?.property_flag?.red_flag || 0) +
                        (isCount?.property_flag?.blue_flag || 0) >
                      0 ? (
                        <span className="isCountvalueds">
                          {(isCount?.property_flag?.red_flag || 0) +
                            (isCount?.property_flag?.blue_flag || 0)}
                          <KeyboardArrowDownOutlinedIcon />
                        </span>
                      ) : (
                        <span className="isCountvalueds">
                          <KeyboardArrowDownOutlinedIcon />
                        </span>
                      )}
                      {/* {(isCount?.property_flag?.customer || 0) +
                      (isCount?.property_flag?.blue_flag || 0) ===
                      0 && <KeyboardArrowDownOutlinedIcon />} */}
                      {/* <KeyboardArrowDownOutlinedIcon /> */}
                    </span>
                  </h4>
                </div>
              </li>
            )}
            {/* {checkMultiplePermission[
              ("CAN-LIST-PROPERTY__BLUE_FLAG",
              "CAN-LIST-PROPERTY__RED_FLAG",
              "CAN-LIST-PROPERTY__BLUE_FLAG")
            ] && ( */}
            {/*  )} */}
            {activeMenu === "PropertyFlag" && (
              <ul className="sub-menu show">
                {checkPermission("CAN-LIST-PROPERTY__BLUE_FLAG") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/property-flag-blue");
                      setIsActiveViewNotification("property_flag/blue");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "property-flag-blue"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Blue Flag
                    </h4>
                    {isCount?.property_flag?.blue_flag > 0 && (
                      <span className="isCountvalued">
                        {isCount?.property_flag?.blue_flag}
                      </span>
                    )}
                  </li>
                )}
                {checkPermission("CAN-LIST-PROPERTY__RED_FLAG") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/property-flag-red");
                      setIsActiveViewNotification("property_flag/red");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "property-flag-red"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Red Flag
                    </h4>
                    {isCount?.property_flag?.red_flag > 0 && (
                      <span className="isCountvalued">
                        {isCount?.property_flag?.red_flag}
                      </span>
                    )}
                  </li>
                )}
              </ul>
            )}
            {/* Master */}
            {checkMultiplePermission([
              "CAN-LIST-SERVICES",
              "CAN-LIST-AMENITIES",
              "CAN-LIST-PROPERTY_TAGS",
              "CAN-LIST-BANNER",
              "CAN-LIST-VIDEO",
              "CAN-LIST-TIME_SLOT",
              "CAN-LIST-HOTEL_CATEGORIES",
              "CAN-LIST-ROOM_CATEGORIES",
              "CAN-LIST-TIPS",
              "CAN-LIST-COMMISSION",
              "CAN-LIST-CHECK_IN",
              "CAN-LIST-AGE",
              "CAN-LIST-MASTERMMC",
              "CAN-LIST-LOCATION",
              "CAN-LIST-DELETE_ACCOUNT",
              "CAN-LIST-HOUSE_POLICY",
              "CAN-LIST-TERMS_&_CONDITIONS",
            ]) && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick(
                    "master",
                    checkPermission("CAN-LIST-SERVICES")
                      ? "/services"
                      : checkPermission("CAN-LIST-AMENITIES")
                        ? "/amenities"
                        : checkPermission("CAN-LIST-PROPERTY_TAGS")
                          ? "/property-tags"
                          : checkPermission("CAN-LIST-BANNER")
                            ? "/banners"
                            : checkPermission("CAN-LIST-VIDEO")
                              ? "/vedio"
                              : checkPermission("CAN-LIST-TIME_SLOT")
                                ? "/time-slot"
                                : checkPermission("CAN-LIST-HOTEL_CATEGORIES")
                                  ? "/hotel-categories"
                                  : checkPermission("CAN-LIST-ROOM_CATEGORIES")
                                    ? "/room-categories"
                                    : checkPermission("CAN-LIST-TIPS")
                                      ? "/tips"
                                      : checkPermission("CAN-LIST-COMMISSION")
                                        ? "/commission"
                                        : checkPermission("CAN-LIST-CHECK_IN")
                                          ? "/check-in"
                                          : checkPermission("CAN-LIST-AGE")
                                            ? "/minimum-age"
                                            : checkPermission(
                                                  "CAN-LIST-MASTERMMC",
                                                )
                                              ? "/mmc"
                                              : checkPermission(
                                                    "CAN-LIST-LOCATION",
                                                  )
                                                ? "/location"
                                                : checkPermission(
                                                      "CAN-LIST-DELETE_ACCOUNT",
                                                    )
                                                  ? "/delete-account"
                                                  : checkPermission(
                                                        "CAN-LIST-HOUSE_POLICY",
                                                      )
                                                    ? "/house-policy"
                                                    : checkPermission(
                                                          "CAN-LIST-TERMS_&_CONDITIONS",
                                                        )
                                                      ? "/terms-condition"
                                                      : "",
                  );
                  setIsActiveViewNotification("master/services");
                }}
              >
                <h4
                  className={`ps-3 ${
                    [
                      "services",
                      "services-edit",
                      "amenities",
                      "location",
                      "vedio",
                      "banners",
                      "home-banners",
                      "add-home-banners",
                      "property-banners",
                      "add-property-banners",
                      "refer-and-earn",
                      "booking-details",
                      "wallet-banner",
                      "day-outing",
                      "owner-banner",
                      "property-tags",
                      "time-slot",
                      "hotel-categories",
                      "room-categories",
                      "tips",
                      "commission",
                      "check-in",
                      "minimum-age",
                      "mmc",
                      "arrival-sos",
                      "room-sos",
                      "tutorial-videos",
                    ].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <img
                    src={
                      [
                        "services",
                        "services-edit",
                        "amenities",
                        "location",
                        "vedio",
                        "banners",
                        "home-banners",
                        "add-home-banners",
                        "property-banners",
                        "add-property-banners",
                        "refer-and-earn",
                        "booking-details",
                        "wallet-banner",
                        "day-outing",
                        "owner-banner",
                        "property-tags",
                        "time-slot",
                        "hotel-categories",
                        "room-categories",
                        "tips",
                        "commission",
                        "check-in",
                        "minimum-age",
                        "mmc",
                        "arrival-sos",
                        "room-sos",
                        "tutorial-videos",
                      ].includes(splitLocation[1])
                        ? master_act_icon
                        : master_icon
                    }
                    className="icon"
                    alt=""
                  />
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                    Master <KeyboardArrowDownOutlinedIcon />
                  </span>
                </h4>
              </li>
            )}
            {activeMenu === "master" && (
              <ul className="sub-menu show">
                {checkPermission("CAN-LIST-SERVICES") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/services");
                      setIsActiveViewNotification("master/services");
                    }}
                  >
                    <h4
                      className={`${
                        ["services", "services-edit"].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Services
                    </h4>
                  </li>
                )}

                {checkPermission("CAN-LIST-AMENITIES") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/amenities");
                      setIsActiveViewNotification("master/amenities");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "amenities" ||
                        splitLocation[1] === "amenities-add"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Amenities
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-PROPERTY_TAGS") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/property-tags");
                      setIsActiveViewNotification("master/property_tags");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "property-tags"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Property Tags
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-BANNER") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/banners");
                      setIsActiveViewNotification("master/banners");
                    }}
                  >
                    <h4
                      className={`${
                        [
                          "banners",
                          "banners",
                          "home-banners",
                          "add-home-banners",
                          "property-banners",
                          "add-property-banners",
                          "refer-and-earn",
                          "booking-details",
                          "wallet-banner",
                          "day-outing",
                          "owner-banner",
                        ].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Banner
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-VIDEO") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/vedio");
                      setIsActiveViewNotification("master/video");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "vedio" ? "f3 sub_active" : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Video
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-TIME_SLOT") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/time-slot");
                      setIsActiveViewNotification("master/time_slot");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "time-slot" ? "f3 sub_active" : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Time Slot
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-HOTEL_CATEGORIES") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/hotel-categories");
                      setIsActiveViewNotification("master/hotel_categories");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "hotel-categories"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Hotel Categories
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-ROOM_CATEGORIES") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/room-categories");
                      setIsActiveViewNotification("master/room_categories");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "room-categories"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Room Categories
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-TIPS") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/tips");
                      setIsActiveViewNotification("master/tips");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "tips" ? "f3 sub_active" : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Tips
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-COMMISSION") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/commission");
                      setIsActiveViewNotification("master/commission");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "commission" ? "f3 sub_active" : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Commission
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-CHECK_IN") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/check-in");
                      setIsActiveViewNotification("master/check_in");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "check-in" ? "f3 sub_active" : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Check In
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-AGE") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/minimum-age");
                      setIsActiveViewNotification("master/minimum_age");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "minimum-age"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Age
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-MASTERMMC") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/mmc");
                      setIsActiveViewNotification("master/mmc");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "mmc" ? "f3 sub_active" : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      MMC
                    </h4>
                  </li>
                )}

                {checkPermission("CAN-LIST-LOCATION") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/location");
                      setIsActiveViewNotification("master/location");
                    }}
                  >
                    <h4
                      className={`${
                        ["location"].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } text ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Location
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-DELETE_ACCOUNT") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => navigate("/delete-account")}
                  >
                    <h4
                      className={`${
                        ["delete-account"].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } text ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Delete Account
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-BOOKING_CANCEL_REASON") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => navigate("/cancel-reason")}
                  >
                    <h4
                      className={`${
                        ["cancel-reason"].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } text ps-4  fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Booking Cancel Reason
                    </h4>
                  </li>
                )}

                {checkPermission("CAN-LIST-HOUSE_POLICY") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/house-policy");
                      setIsActiveViewNotification("refer/house_policy");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "house-policy"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      House Policy
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-TERMS_&_CONDITIONS") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/terms-condition");
                      setIsActiveViewNotification("refer/terms_condition");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "terms-condition"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Terms & Conditions
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-REFER_MESSAGE") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => navigate("/refer-message")}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "refer-message"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Refer Message
                    </h4>
                  </li>
                )}
                {/* {checkPermission("CAN-LIST-REFER_MESSAGE") && ( */}
                <li
                  className="nav_link trans my-0"
                  onClick={() => navigate("/arrival-sos")}
                >
                  <h4
                    className={`${
                      splitLocation[1] === "arrival-sos" ? "f3 sub_active" : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                  >
                    Arrival SOS
                  </h4>
                </li>
                <li
                  className="nav_link trans my-0"
                  onClick={() => navigate("/room-sos")}
                >
                  <h4
                    className={`${
                      splitLocation[1] === "room-sos" ? "f3 sub_active" : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                  >
                    Room SOS
                  </h4>
                </li>
                <li
                  className="nav_link trans my-0"
                  onClick={() => navigate("/tutorial-videos")}
                >
                  <h4
                    className={`${
                      splitLocation[1] === "tutorial-videos"
                        ? "f3 sub_active"
                        : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                  >
                    Tutorial Videos
                  </h4>
                </li>
                {/* // )} */}
              </ul>
            )}
            {/* Wallet transcation */}
            {checkMultiplePermission([
              "CAN-LIST-WALLETUSER",
              "CAN-LIST-WALLETOWNER",
            ]) && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick(
                    "wallet-transaction",
                    checkPermission("CAN-LIST-WALLETUSER")
                      ? "/wallettransaction"
                      : checkPermission("CAN-LIST-WALLETOWNER")
                        ? "/wallet-owner"
                        : "",
                  );
                  setIsActiveViewNotification("wallet/transaction_list");
                }}
              >
                <h4
                  className={`ps-3 ${
                    [
                      "wallet-transaction",
                      "wallettransactionadd",
                      "wallettransaction",
                      "wallet-owner",
                      "wallet-owner-add",
                    ].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <img
                    src={
                      ["properties"].includes(splitLocation[1])
                        ? Wallet_act
                        : Wallet
                    }
                    className="icon"
                    alt=""
                  />
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                    Wallet Transaction <KeyboardArrowDownOutlinedIcon />
                  </span>
                </h4>
              </li>
            )}
            {activeMenu === "wallet-transaction" && (
              <ul className="sub-menu show">
                {checkPermission("CAN-LIST-WALLETUSER") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/wallettransaction");
                      setIsActiveViewNotification("wallet/transaction_list");
                    }}
                  >
                    <h4
                      className={`${
                        [
                          "wallet-transaction",
                          "wallettransactionadd",
                          "wallettransaction",
                        ].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      User
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-WALLETOWNER") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/wallet-owner");
                      setIsActiveViewNotification("wallet/owner");
                    }}
                  >
                    <h4
                      className={`${
                        [
                          "wallet-transaction",
                          "wallet-owner",
                          "wallet-owner-add",
                        ].includes(splitLocation[1])
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Owner
                    </h4>
                  </li>
                )}
              </ul>
            )}
            {/* Coupon amount */}
            {checkPermission("CAN-LIST-COUPON") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick("coupon", "/coupon");
                  setIsActiveViewNotification("coupon/list");
                }}
              >
                <h4
                  className={`ps-3 ${
                    ["coupon", "couponadd", "coupon-single-add"].includes(
                      splitLocation[1],
                    )
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <img
                    src={
                      ["properties"].includes(splitLocation[1])
                        ? coupon_active
                        : coupon_deactive
                    }
                    className="icon"
                    alt=""
                  />
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                    Coupon
                  </span>
                </h4>
              </li>
            )}
            {/* Bookings */}
            {checkPermission("CAN-LIST-BOOKINGS") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick("booking-list", "/booking-list");
                  setIsActiveViewNotification("booking/list");
                }}
              >
                <h4
                  className={`ps-3 ${
                    [
                      "booking-list",
                      "booking-view",
                      "booking-list-view",
                    ].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <img
                    src={
                      [
                        "booking-list",
                        "booking-view",
                        "booking-list-view",
                      ].includes(splitLocation[1])
                        ? booking_act
                        : booking
                    }
                    className="icon"
                    alt=""
                  />
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                    Bookings
                  </span>
                </h4>
              </li>
            )}

            {/* SOS */}
            {/* {checkPermission("CAN-LIST-BOOKINGS") && ( */}
            <li
              className="nav_link trans"
              onClick={() => {
                handleMenuClick("sos-alerts", "/sos-alerts");
                setIsActiveViewNotification("sos-alerts");
              }}
            >
              <h4
                className={`ps-3 ${
                  ["sos-alerts"].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    ["sos-alerts"].includes(splitLocation[1]) ? sosactive : sos
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  SOS Alert
                </span>
              </h4>
            </li>
            {/* )} */}
            {/* Transaction */}
            {checkPermission("CAN-LIST-TRANSACTION") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick("transaction-list", `/transaction-list`);
                  setIsActiveViewNotification(`transaction/list`);
                }}
              >
                <div
                  className={`ps-3 ${
                    ["transaction-list", "transaction-view"].includes(
                      splitLocation[1],
                    )
                      ? "f3 active_bar"
                      : ""
                  }`}
                  style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                >
                  <h4
                    style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                    // className={`ps-3 ${
                    //   ["absentlist"].includes(splitLocation[1])
                    //     ? "f3 active_bar"
                    //     : ""
                    // }`}
                  >
                    <img
                      src={
                        ["transaction-list", "transaction-view"].includes(
                          splitLocation[1],
                        )
                          ? transaction_act
                          : transaction
                      }
                      className="icon"
                      alt=""
                    />
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                      Transaction
                    </span>
                  </h4>
                  {(isCount?.transactions?.upcoming || 0) +
                    (isCount?.transactions?.cancelled || 0) +
                    (isCount?.transactions?.hold || 0) >
                    0 && (
                    <span className="isCountvalued">
                      {(isCount?.transactions?.upcoming || 0) +
                        (isCount?.transactions?.cancelled || 0) +
                        (isCount?.transactions?.hold || 0)}
                    </span>
                  )}
                </div>
                {/* <h4
                  className={`ps-3 ${
                    ["transaction-list", "transaction-view"].includes(
                      splitLocation[1],
                    )
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <img
                    src={
                      ["transaction-list", "transaction-view"].includes(
                        splitLocation[1],
                      )
                        ? transaction_act
                        : transaction
                    }
                    className="icon"
                    alt=""
                  />
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                    Transaction
                  </span>
                </h4> */}
              </li>
            )}
            {checkPermission("CAN-LIST-FAILED_TRANSACTION") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick("failed_transaction", `/failed_transaction`);
                  // setIsActiveViewNotification(`transaction/list`);
                }}
              >
                <div
                  className={`ps-3 ${
                    [
                      "failed_transaction",
                      "userFailedNotesTransaction",
                    ].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                  style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                >
                  <h4
                    style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                    // className={`ps-3 ${
                    //   ["absentlist"].includes(splitLocation[1])
                    //     ? "f3 active_bar"
                    //     : ""
                    // }`}
                  >
                    <img
                      src={
                        [
                          "failed_transaction",
                          "userFailedNotesTransaction",
                        ].includes(splitLocation[1])
                          ? SubtitlesSlashActive
                          : SubtitlesSlash
                      }
                      className="icon"
                      alt=""
                    />
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                      Failed Transaction
                    </span>
                  </h4>
                </div>
              </li>
            )}
            {checkPermission("CAN-LIST-INVOICE_USER") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick("invoice-user", `/invoice-user`);
                  setIsActiveViewNotification(`invoice-user/list`);
                }}
              >
                <div
                  className={`ps-3 ${
                    ["invoice-user", "transaction-view"].includes(
                      splitLocation[1],
                    )
                      ? "f3 active_bar"
                      : ""
                  }`}
                  style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                >
                  <h4
                    style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                    // className={`ps-3 ${
                    //   ["absentlist"].includes(splitLocation[1])
                    //     ? "f3 active_bar"
                    //     : ""
                    // }`}
                  >
                    <img
                      src={
                        ["invoice-user", "transaction-view"].includes(
                          splitLocation[1],
                        )
                          ? invoice_purpple_Icon
                          : invoice_gray_Icon
                      }
                      className="icon"
                      alt=""
                      style={{ width: 30 }}
                    />
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                      InvoiceUser
                    </span>
                  </h4>
                  {/* {(isCount?.transactions?.upcoming || 0) +
                    (isCount?.transactions?.cancelled || 0) +
                    (isCount?.transactions?.hold || 0) >
                    0 && (
                    <span className="isCountvalued">
                      {(isCount?.transactions?.upcoming || 0) +
                        (isCount?.transactions?.cancelled || 0) +
                        (isCount?.transactions?.hold || 0)}
                    </span>
                  )} */}
                </div>
                {/* <h4
                  className={`ps-3 ${
                    ["transaction-list", "transaction-view"].includes(
                      splitLocation[1],
                    )
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <img
                    src={
                      ["transaction-list", "transaction-view"].includes(
                        splitLocation[1],
                      )
                        ? transaction_act
                        : transaction
                    }
                    className="icon"
                    alt=""
                  />
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                    Transaction
                  </span>
                </h4> */}
              </li>
            )}
            {/* Refer & Earn */}
            {checkPermission("CAN-LIST-REFER_&_EARN") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/referearn");
                  setIsActiveViewNotification("master/refer_and_earn");
                }}
              >
                <h4
                  className={`ps-3 ${
                    ["referearn", "referearnview"].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <img
                    src={
                      ["house-policy", "terms-condition"].includes(
                        splitLocation[1],
                      )
                        ? refer_icon
                        : refer_icon
                    }
                    className="icon"
                    alt=""
                  />
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                    Refer & Earn
                  </span>
                </h4>
              </li>
            )}
            {/* Wish List */}
            {checkPermission("CAN-LIST-WISH_LIST") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/wishlist");
                  setIsActiveViewNotification("wishlist/list");
                }}
              >
                <h4
                  className={`ps-3 ${
                    ["wishlist", "wishlistview"].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <img
                    src={
                      ["wishlist", "wishlistview"].includes(splitLocation[1])
                        ? Wallet_act
                        : Wallet
                    }
                    className="icon"
                    alt=""
                  />
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                    Wish List
                  </span>
                </h4>
              </li>
            )}
            {/* Notify Me */}
            {checkPermission("CAN-LIST-NOTIFY_ME") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/notifyme");
                  setIsActiveViewNotification("notify_me/list");
                }}
              >
                <div
                  className={`ps-3 ${
                    ["notifyme", "notifymeview"].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                  style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                >
                  <h4
                    style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                  >
                    <img
                      src={
                        ["house-policy", "terms-condition"].includes(
                          splitLocation[1],
                        )
                          ? wishlist
                          : wishlist
                      }
                      className="icon"
                      alt=""
                    />
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                      Notify Me
                    </span>
                  </h4>
                  {isCount?.notify_me?.notify_me > 0 && (
                    <span className="isCountvalued">
                      {isCount?.notify_me?.notify_me}
                    </span>
                  )}
                </div>
              </li>
            )}
            {/* Review */}
            {checkPermission("CAN-LIST-REVIEW") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick("review", "/review");
                  setIsActiveViewNotification("review/list");
                }}
              >
                <div
                  className={`ps-3 ${
                    ["review", "reviewview"].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <h4
                    style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                  >
                    <img
                      src={
                        ["review", "reviewview"].includes(splitLocation[1])
                          ? review_active
                          : review_deactive
                      }
                      className="icon"
                      alt=""
                    />
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                      Review
                    </span>
                  </h4>
                  {isCount?.reviews?.review > 0 && (
                    <span className="isCountvalued">
                      {isCount?.reviews?.review}
                    </span>
                  )}
                </div>
              </li>
            )}
            {checkPermission("CAN-LIST-ABSENT_LIST") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  navigate("/absentlist");
                  setIsActiveViewNotification("absent/absent");
                }}
              >
                <div
                  className={`ps-2 d-flex ${
                    ["absentlist"].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                  style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                >
                  <h4
                    style={{ alignItems: "center", paddingRight: 3, margin: 0 }}
                    // className={`ps-3 ${
                    //   ["absentlist"].includes(splitLocation[1])
                    //     ? "f3 active_bar"
                    //     : ""
                    // }`}
                  >
                    <img
                      src={
                        ["absentlist"].includes(splitLocation[1])
                          ? review_active
                          : review_deactive
                      }
                      className="icon"
                      alt=""
                    />
                    <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                      Absent
                    </span>
                  </h4>
                  {isCount?.absent?.absent > 0 && (
                    <span className="isCountvalued">
                      {isCount?.absent?.absent}
                    </span>
                  )}
                </div>
              </li>
            )}
            {/* Settings Menu */}
            {checkMultiplePermission([
              "CAN-LIST-IN-APP_CONTROL",
              "CAN-LIST-MAINTENANCE",
              "CAN-LIST-DAILY_LOG_REPORT",
              "CAN-LIST-SMS_GATEWAY",
              "CAN-LIST-SUPPORT_NUMBER",
              "CAN-LIST-OFFICE_IP",
              "CAN-LIST-AUDIT_LOG",
              "CAN-LIST-PAYMENT_GATEWAY",
            ]) && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick(
                    "vow-settings",
                    checkPermission("CAN-LIST-IN-APP_CONTROL")
                      ? "/vow-settings"
                      : checkPermission("CAN-LIST-MAINTENANCE")
                        ? "/maintenance"
                        : checkPermission("CAN-LIST-DAILY_LOG_REPORT")
                          ? "/daily-log"
                          : checkPermission("CAN-LIST-SMS_GATEWAY")
                            ? "/sms-gateway"
                            : checkPermission("CAN-LIST-SUPPORT_NUMBER")
                              ? "/whatsapp-details"
                              : checkPermission("CAN-LIST-SUPPORT_NUMBER")
                                ? "/whatsapp-details"
                                : checkPermission("CAN-LIST-OFFICE_IP")
                                  ? "/office-ip"
                                  : checkPermission("CAN-LIST-AUDIT_LOG")
                                    ? "/audit-log"
                                    : checkPermission(
                                          "CAN-LIST-PAYMENT_GATEWAY",
                                        )
                                      ? "/payment-gateway"
                                      : "/",
                  );
                  setIsActiveViewNotification("settings/vow_settings");
                }}
              >
                <h4
                  className={`ps-3 ${
                    [
                      "vow-settings",
                      "maintenance",
                      "daily-log",
                      "sms-gateway",
                      "whatsapp-details",
                      "office-ip",
                      "audit-log",
                      "payment-gateway",
                      "sos-alert",
                      "razorpay-key",
                    ].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <img
                    src={
                      [
                        "vow-settings",
                        "maintenance",
                        "daily-log",
                        "sms-gateway",
                        "whatsapp-details",
                        "office-ip",
                        "audit-log",
                        "payment-gateway",
                        "sos-alert",
                        "razorpay-key",
                      ].includes(splitLocation[1])
                        ? vow_settings
                        : vow_settings
                    }
                    className="icon"
                    alt=""
                  />
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                    Settings <KeyboardArrowDownOutlinedIcon />
                  </span>
                </h4>
              </li>
            )}
            {activeMenu === "vow-settings" && (
              <ul className="sub-menu show">
                {checkPermission("CAN-LIST-IN-APP_CONTROL") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/vow-settings");
                      setIsActiveViewNotification("settings/vow_settings");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "vow-settings"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      In-app Control
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-MAINTENANCE") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/maintenance");
                      setIsActiveViewNotification("settings/maintenance");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "maintenance"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Maintenance
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-DAILY_LOG_REPORT") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/daily-log");
                      setIsActiveViewNotification("settings/daily_log");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "daily-log" ? "f3 sub_active" : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Daily log report
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-SMS_GATEWAY") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/sms-gateway");
                      setIsActiveViewNotification("settings/sms-gateway");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "sms-gateway"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      SMS Gateway
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-SUPPORT_NUMBER") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/whatsapp-details");
                      setIsActiveViewNotification("settings/whatsapp-details");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "whatsapp-details"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Support Number
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-OFFICE_IP") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/office-ip");
                      setIsActiveViewNotification("settings/office-ip");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "office-ip" ? "f3 sub_active" : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Office IP
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-AUDIT_LOG") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/audit-log");
                      setIsActiveViewNotification("settings/audit-log");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "audit-log" ? "f3 sub_active" : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Audit Log
                    </h4>
                  </li>
                )}
                {checkPermission("CAN-LIST-PAYMENT_GATEWAY") && (
                  <li
                    className="nav_link trans my-0"
                    onClick={() => {
                      navigate("/payment-gateway");
                      // setIsActiveViewNotification("settings/audit-log");
                    }}
                  >
                    <h4
                      className={`${
                        splitLocation[1] === "payment-gateway"
                          ? "f3 sub_active"
                          : ""
                      } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                    >
                      Payment GateWay
                    </h4>
                  </li>
                )}
                <li
                  className="nav_link trans my-0"
                  onClick={() => {
                    navigate("/sos-alert");
                    // setIsActiveViewNotification("settings/audit-log");
                  }}
                >
                  <h4
                    className={`${
                      splitLocation[1] === "sos-alert" ? "f3 sub_active" : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                  >
                    SOS Alert
                  </h4>
                </li>
                <li
                  className="nav_link trans my-0"
                  onClick={() => {
                    navigate("/firebaseshow");
                    // setIsActiveViewNotification("settings/audit-log");
                  }}
                >
                  <h4
                    className={`${
                      splitLocation[1] === "firebaseshow" ? "f3 sub_active" : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                  >
                    FireBase Show
                  </h4>
                </li>
              </ul>
            )}
            {/* Notification */}
            {checkPermission("CAN-LIST-NOTIFICATION") && (
              <li
                className="nav_link trans"
                onClick={() => {
                  handleMenuClick("notification", "/user-list");
                  setIsActiveViewNotification("notification/user-list");
                }}
              >
                <h4
                  className={`ps-3 ${
                    [
                      // "absentlist",
                      "wallettransactionadd",
                      "wallettransaction",
                      "wallet-owner",
                      "wallet-owner-add",
                      "user-list",
                      "user-notification-add",
                    ].includes(splitLocation[1])
                      ? "f3 active_bar"
                      : ""
                  }`}
                >
                  <img
                    src={
                      ["user-list"].includes(splitLocation[1])
                        ? bell_purple
                        : bell_gray
                    }
                    className="icon"
                    alt=""
                  />
                  <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                    Notification <KeyboardArrowDownOutlinedIcon />
                  </span>
                </h4>
              </li>
            )}
            {activeMenu === "notification" && (
              <ul className="sub-menu show">
                <li
                  className="nav_link trans my-0"
                  onClick={() => {
                    navigate("/user-list");
                    setIsActiveViewNotification("notification/user_list");
                  }}
                >
                  <h4
                    className={`${
                      [
                        "wallet-transaction",
                        "wallet-owner",
                        "wallet-owner-add",
                        "user-list",
                        "user-notification-add",
                      ].includes(splitLocation[1])
                        ? "f3 sub_active"
                        : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                  >
                    User
                  </h4>
                </li>
              </ul>
            )}

            {/* AI */}

            <li
              className="nav_link trans"
              onClick={() => {
                handleMenuClick("ai", "/ai-report");
                setIsActiveViewNotification("ai/ai-report");
              }}
            >
              <h4
                className={`ps-3 ${
                  [
                    // "absentlist",
                    // "wallettransactionadd",
                    // "wallettransaction",
                    // "wallet-owner",
                    // "wallet-owner-add",
                    // "user-list",
                    "ai-report",
                    "ai-area",
                    "ai-notification",
                    "ai-ware",
                  ].includes(splitLocation[1])
                    ? "f3 active_bar"
                    : ""
                }`}
              >
                <img
                  src={
                    [
                      "ai-report",
                      "ai-notification",
                      "ai-area",
                      "ai-ware",
                    ].includes(splitLocation[1])
                      ? bell_purple
                      : bell_gray
                  }
                  className="icon"
                  alt=""
                />
                <span className="text text-nowrap f3 ps-1 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 d-flex ac-jb w-100">
                  AI Support
                  <KeyboardArrowDownOutlinedIcon />
                </span>
              </h4>
            </li>

            {activeMenu === "ai" && (
              <ul className="sub-menu show">
                <li
                  className="nav_link trans my-0"
                  onClick={() => {
                    navigate("/ai-report");
                    // setIsActiveViewNotification("notification/user_list");
                  }}
                >
                  <h4
                    className={`${
                      ["ai-report"].includes(splitLocation[1])
                        ? "f3 sub_active"
                        : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                  >
                    AI Review
                  </h4>
                </li>
                <li
                  className="nav_link trans my-0"
                  onClick={() => {
                    navigate("/ai-area");
                    // setIsActiveViewNotification("notification/user_list");
                  }}
                >
                  <h4
                    className={`${
                      ["ai-area"].includes(splitLocation[1])
                        ? "f3 sub_active"
                        : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                  >
                    AI Area
                  </h4>
                </li>
                <li
                  className="nav_link trans my-0"
                  onClick={() => {
                    navigate("/ai-notification");
                  }}
                >
                  <h4
                    className={`${
                      ["ai-notification"].includes(splitLocation[1])
                        ? "f3 sub_active"
                        : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                  >
                    AI Notication
                  </h4>
                </li>

                <li
                  className="nav_link trans my-0"
                  onClick={() => {
                    navigate("/ai-ware");
                    // setIsActiveViewNotification("settings/audit-log");
                  }}
                >
                  <h4
                    className={`${
                      splitLocation[1] === "ai-ware" ? "f3 sub_active" : ""
                    } text ps-4 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-16 my-0 sub-dropdown`}
                  >
                    AI Token
                  </h4>
                </li>
              </ul>
            )}
          </ul>
        </div>
      </div>

      {/* Logout Button */}
      <div className="d-flex ac-jb py-3 px-2 bg-primary2">
        <h4
          onClick={() => setPopup(true)}
          className="f4 fs-md-13 fs-xl-16 mb-0 ms-4 pointer"
        >
          Logout
        </h4>
        {menuOpen ? (
          <KeyboardArrowUpIcon
            className="arrow-down "
            onClick={handleCloseMenu}
          />
        ) : (
          <KeyboardArrowDownIcon
            className="arrow-down "
            onClick={() => setMenuOpen(true)}
          />
        )}
      </div>

      {/* Logout Confirmation Popup */}
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <h2 className="f4 mt-4">Logout</h2>
            <p className="f3 mt-4">Are you sure you want to logout?</p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="add-btn w-40">
                No
              </button>
              <button onClick={handleLogout} className="back-btn f2 w-40">
                {loading ? "Loading..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileNavBar;
